import { render } from "./SecondOpinionRequest.vue?vue&type=template&id=6ccf781b&scoped=true&ts=true"
import script from "./SecondOpinionRequest.vue?vue&type=script&lang=ts"
export * from "./SecondOpinionRequest.vue?vue&type=script&lang=ts"

import "./SecondOpinionRequest.vue?vue&type=style&index=0&id=6ccf781b&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccf781b"]])

export default __exports__